import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propStr } from '../../../helpers/custom-prop-types';
const ClockIcon = ({ className }) => (_jsx("svg", Object.assign({ className: `svg-clock-icon ${className}`, height: '15', viewBox: '0 0 15 15', width: '15', xmlns: 'http://www.w3.org/2000/svg' }, { children: _jsx("path", { d: 'M143.49,435a7.5,7.5,0,1,1,7.5-7.5A7.508,7.508,0,0,1,143.49,435Zm.007-13.5a6,6,0,1,0,6,6A6.007,6.007,0,0,0,143.5,421.5Zm3.01,8.919a.552.552,0,0,1-.28-.077l-3.112-1.868a.746.746,0,0,1-.368-.645v-3.54a.541.541,0,0,1,.54-.54h.045a.541.541,0,0,1,.54.54v3.4l2.9,1.725a.525.525,0,0,1,.251.329.531.531,0,0,1-.063.413A.522.522,0,0,1,146.508,430.419Z', fill: '#a1a7b2', transform: 'translate(-135.99 -420)' }) })));
ClockIcon.propTypes = {
    className: propStr(),
};
ClockIcon.defaultProps = {
    className: '',
};
export default ClockIcon;
